import state from './leaseSuppliesState'
import mutations from './leaseSuppliesMutations'
import actions from './leaseSuppliesActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
